// eslint-disable-next-line import/prefer-default-export
export let EExternalSource;
(function (EExternalSource) {
  EExternalSource["Gcalendar"] = "gcalendar";
  EExternalSource["Successehs"] = "successehs";
  EExternalSource["Drchrono"] = "drchrono";
  EExternalSource["Dentrix"] = "dentrix";
  EExternalSource["Webpt"] = "webpt";
  EExternalSource["Theraoffice"] = "theraoffice";
  EExternalSource["Mi7"] = "mi7";
  EExternalSource["Practicefusion"] = "practicefusion";
  EExternalSource["Advancedmd"] = "advancedmd";
  EExternalSource["Acomrapidpm"] = "acomrapidpm";
  EExternalSource["Kareo"] = "kareo";
  EExternalSource["Nextech"] = "nextech";
  EExternalSource["Mwtherapy"] = "mwtherapy";
  EExternalSource["Clinicient"] = "clinicient";
  EExternalSource["Carecloud"] = "carecloud";
  EExternalSource["Eclinicalmobile"] = "eclinicalmobile";
  EExternalSource["Duxware"] = "duxware";
  EExternalSource["Labretriever"] = "labretriever";
  EExternalSource["Optimispt"] = "optimispt";
  EExternalSource["Referral"] = "referral";
  EExternalSource["Recall"] = "recall";
  EExternalSource["Allscriptspm"] = "allscriptspm";
  EExternalSource["Lytec"] = "lytec";
  EExternalSource["Brightree"] = "brightree";
  EExternalSource["Fullslate"] = "fullslate";
  EExternalSource["Nuemd"] = "nuemd";
  EExternalSource["Centricityps"] = "centricityps";
  EExternalSource["Officeally"] = "officeally";
  EExternalSource["Greenwayintergy"] = "greenwayintergy";
  EExternalSource["Compulink"] = "compulink";
  EExternalSource["Adspm"] = "adspm";
  EExternalSource["Dsnpm"] = "dsnpm";
  EExternalSource["Lumamock"] = "lumamock";
  EExternalSource["Medicalmastermind"] = "medicalmastermind";
  EExternalSource["Meditouch"] = "meditouch";
  EExternalSource["Healthnautica"] = "healthnautica";
  EExternalSource["Ezemrx"] = "ezemrx";
  EExternalSource["Hl7"] = "hl7";
  EExternalSource["Amazingcharts"] = "amazingcharts";
  EExternalSource["Greenwayprimesuite"] = "greenwayprimesuite";
  EExternalSource["Raintree"] = "raintree";
  EExternalSource["Athenahealth"] = "athenahealth";
  EExternalSource["Revflow"] = "revflow";
  EExternalSource["Eclinicalworks10e"] = "eclinicalworks10e";
  EExternalSource["Hl7pickup"] = "hl7pickup";
  EExternalSource["Mindbody"] = "mindbody";
  EExternalSource["Eclinicalworkssql"] = "eclinicalworkssql";
  EExternalSource["Nextgen"] = "nextgen";
  EExternalSource["Practiceperfect"] = "practiceperfect";
  EExternalSource["Avimark"] = "avimark";
  EExternalSource["Clinix"] = "clinix";
  EExternalSource["Keymedical"] = "keymedical";
  EExternalSource["Mdoffice"] = "mdoffice";
  EExternalSource["Webedoctor"] = "webedoctor";
  EExternalSource["Emapm"] = "emapm";
  EExternalSource["Medinformatix"] = "medinformatix";
  EExternalSource["Imsgo"] = "imsgo";
  EExternalSource["Emds"] = "emds";
  EExternalSource["Allscriptsunity"] = "allscriptsunity";
  EExternalSource["Medevolve"] = "medevolve";
  EExternalSource["Caretracker"] = "caretracker";
  EExternalSource["Clearpractice"] = "clearpractice";
  EExternalSource["Valant"] = "valant";
  EExternalSource["Micromd"] = "micromd";
  EExternalSource["Systemedx"] = "systemedx";
  EExternalSource["Medicalmaster"] = "medicalmaster";
  EExternalSource["Athenamdp"] = "athenamdp";
  EExternalSource["Gmed"] = "gmed";
  EExternalSource["Roche"] = "roche";
  EExternalSource["Onetouch"] = "onetouch";
  EExternalSource["Somnoware"] = "somnoware";
  EExternalSource["Managementplus"] = "managementplus";
  EExternalSource["Lumacare"] = "lumacare";
  EExternalSource["Nextechfhir"] = "nextechfhir";
  EExternalSource["Curemd"] = "curemd";
  EExternalSource["Epic"] = "epic";
  EExternalSource["Phoenixortho"] = "phoenixortho";
  EExternalSource["Ezderm"] = "ezderm";
  EExternalSource["Ggastromobile"] = "ggastromobile";
  EExternalSource["Epicconfirmationpickup"] = "epicconfirmationpickup";
  EExternalSource["Cerner"] = "cerner";
  EExternalSource["Allmeds"] = "allmeds";
  EExternalSource["Oncoemrfilepickup"] = "oncoemrfilepickup";
  EExternalSource["Imedicware"] = "imedicware";
  EExternalSource["Modmedfhir"] = "modmedfhir";
  EExternalSource["Clinux"] = "clinux";
  EExternalSource["Acuityscheduling"] = "acuityscheduling";
  EExternalSource["Medstreaming"] = "medstreaming";
  EExternalSource["ISalus"] = "isalus";
  EExternalSource["MeditechExpanse"] = "meditechexpanse";
  EExternalSource["OpenEMR"] = "openemr";
  EExternalSource["Genericfhir"] = "genericfhir";
  EExternalSource["NextechPracticePlus"] = "nextechpracticeplus";
})(EExternalSource || (EExternalSource = {}));